// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #C0DEF0;
  color: #19608f;
  will-change: transform;
  flex-wrap: wrap;
}
@media only screen and (max-width: 768px) {
  .toolbar {
    flex-direction: column;
    justify-content: center;
  }
}
.toolbar .tb-content-wrapper {
  align-items: center;
  background: #C0DEF0;
  color: #19608f;
  display: flex;
  font-weight: 900;
  min-height: 70px;
  padding: 0 12px 0 36px;
}
@media only screen and (max-width: 768px) {
  .toolbar .tb-content-wrapper {
    padding: 0 15px;
    width: 100%;
    justify-content: center;
  }
}
.toolbar .tb-content-wrapper .divider {
  border-left: 1px solid white;
  height: 46px;
  margin: 0px 15px;
  opacity: 1 !important;
}
@media only screen and (max-width: 768px) {
  .toolbar .tb-content-wrapper .divider {
    margin: 0 10px;
    height: 30px;
    display: none;
  }
}
.toolbar .tb-content-wrapper .toolbar-link-home {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #19608f;
  font-size: 4rem;
  text-decoration: none;
  font-weight: 900;
  display: flex;
  align-items: center;
  letter-spacing: -0.8rem;
  margin-right: 0.8rem;
  margin-top: -16px;
  margin-bottom: -16px;
}
@media only screen and (max-width: 600px) {
  .toolbar .tb-content-wrapper .toolbar-link-home {
    align-items: center;
    font-size: 2.5rem;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
.toolbar .tb-content-wrapper span {
  font-size: 1.2rem;
  font-weight: 600;
}
.toolbar .toolbar-background {
  align-self: center;
  flex-shrink: 0;
}
@media only screen and (max-width: 768px) {
  .toolbar .toolbar-background {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["data:;charset=utf-8,*,%0A*::before,%0A*::after%20%7B%0A%20%20%20%20box-sizing:%20border-box;%0A%7D%0A/%20Guardian%20Dashboard%20colors%0A$lt-blue:%20%237DB7CC;%0A$dk-blue:%20%2319608f;%0A%0A$error:%20%23CE3525;%0A$error-dk:%20%23aa3333;%0A$error-hover:%20%23cf4635;%0A$hover-white:%20%23E0E0E0;%0A$light-background:%20%23EFEFEF;%0A%0A$information:%20%2300AEEF;%0A$information-hover:%20%2302BFFF;%0A$text:%20%23414042;%0A$white:%20%23EDEDED;%0A$shadow:%20%23525151;%0A$red:%20%23CB321A;%0A$green:%20%234a8319;%0A%0A$important:%20%23FEBF31;%0A$greyLight:%20%23F8F8F8;%0A$grey0:%20%23EDf0F1;%0A$grey1:%20%23D1D3D4;%0A$grey2:%20%23A7A9AC;%0A$grey3:%20%23808080;%0A$grey3a:%20%23707070;%0A$grey4:%20%23636161;%0A$grey4a:%20%23444343;%0A$pale-blue:%20%23C0DEF0;%0A$pearl-blue:%20%230669B3;%0A$pearl-blue-hover:%20%231786DB;%0A$lt-pearl-blue:%20%2363AEDE;%0A$lt-pearl-blue-hover:%20%234589B3;%0A$icon-blue:%20%234DD9FF;%0A","webpack://./src/styles/Toolbar.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBDyBQ;ECxBR,cDDM;ECEN,sBAAA;EACA,eAAA;AAIJ;AAFI;EATJ;IAUQ,sBAAA;IACA,uBAAA;EAKN;AACF;AAHI;EACI,mBAAA;EACA,mBDaI;ECZJ,cDbE;ECcF,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAKR;AAHQ;EATJ;IAUQ,eAAA;IACA,WAAA;IACA,uBAAA;EAMV;AACF;AAJQ;EACI,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAMZ;AAJY;EANJ;IAOQ,cAAA;IACA,YAAA;IACA,aAAA;EAOd;AACF;AAJQ;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cD3CF;EC4CE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AAMZ;AAJY;EAhBJ;IAiBQ,mBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAOd;AACF;AAJQ;EACI,iBAAA;EACA,gBAAA;AAMZ;AAFI;EACI,kBAAA;EACA,cAAA;AAIR;AAFQ;EAJJ;IAKQ,WAAA;IACA,aAAA;IACA,uBAAA;IACA,gBAAA;EAKV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
